import {
  CardSelectionDropdownTexts,
  CommonTexts,
  DetailsPageTexts,
  FooterComponentTexts,
  HeaderComponentTexts,
  LoginModalTexts,
  OfferListingPageTexts,
  OrderHistoryTexts,
  PreLoginPageTexts,
} from '../environment.interface';

const commonTexts: CommonTexts = {
  back: 'Voltar',
  orderHistory: 'Histórico de Pedidos',
  getStarted: 'Começar',
  loginButtonLabel: 'Entrar',
  orderSummary: 'Resumo do pedido',
  copyCode: 'Copiar Código',
  redeemNow: 'Resgatar Agora',
  validTill: 'Válido até',
  viewDetails: 'Ver detalhes',
  orderId: 'ID do Pedido',
  welcome: 'Bem-vindo',
  errorMsgs: {
    tryLater: 'Algo deu errado, por favor, tente novamente mais tarde.',
    redirectingToOrderHistory:
      'Algo deu errado, redirecionando para o histórico de pedidos',
    paymentFailed: 'Pagamento falhou, tente novamente mais tarde.',
  },
};

const reverificationLogoutText: string =
  'Você será desconectado em {{ countdown }} segundos para reverificação';

const preLoginPage: PreLoginPageTexts = {
  header: {
    heading:
      'Descubra ofertas exclusivas e benefícios premium em parceria com a Visa',
    subHeading: 'Aproveite descontos e ofertas em suas marcas favoritas',
    loginButtonLabel: 'clique aqui para entrar',
    loginSubText: 'Já registrado?',
  },
  programBenefits: {
    tabHeading: 'Benefícios do programa',
    heading: 'Descubra possibilidades ilimitadas com seu cartão Visa',
    offers: {
      title: 'Economize com o Visa',
      description:
        'Tenha acesso a uma ampla variedade de ofertas, incluindo viagens, jogos, streaming, presentes e muito mais.',
      subtext: 'Encontre seus favoritos aqui.',
      linkLabel: 'Explorar ofertas',
    },
  },
  howToRedeem: {
    tabHeading: 'Como resgatar',
    heading: 'Como desbloquear seus benefícios Visa?',
    steps: [
      {
        number: '1',
        title: 'Cadastrar-se',
        description:
          'Se você é novo neste programa, insira os dados do seu cartão para se registrar',
      },
      {
        number: '2',
        title: 'Verifique seu e-mail',
        description: 'Digite seu e-mail registrado e verifique com o OTP',
      },
      {
        number: '3',
        title: 'Verificação 3DS',
        description:
          'Digite os dados do seu cartão para autenticar e desbloquear recompensas',
      },
    ],
  },
};

const offerListingPage: OfferListingPageTexts = {
  heading: 'Aproveite descontos incríveis com seu cartão Visa',
  categoryLabel: 'Categorias',
  allCategoryLabel: 'Todos',
  offersTabLabel: 'Aproveite os descontos',
  dealsTabLabel: 'Ofertas Exclusivas',
  offerCardsConfig: {
    primaryBtnLabel: 'Resgatar Oferta',
  },
};

const orderHistoryPage: OrderHistoryTexts = {
  categories: [
    { name: 'ofertas com desconto', type: 'offer' },
    { name: 'ofertas exclusivas', type: 'exclusive' },
  ],
  noVoucherText: 'sem necessidade de voucher',
  redeemFailedMessages: {
    title: 'Ocorreu um erro',
    subtitle: 'Por favor, tente novamente mais tarde',
  },
  redirectionTexts: {
    hyperlinkText: 'Clique aqui',
    normalText: 'para saber como resgatar o código da oferta.',
  },
  cardUsedText: 'Cartão Usado',
  couponHelperText:
    'Use seu código promocional no checkout no aplicativo/site do comerciante',
  generatedOnText: 'Gerado em',
  merchantOfferText: 'oferta do comerciante',
  noOffersText: 'Nenhuma oferta encontrada',
  statusMessages: {
    cancelled: 'Cancelado',
    failed: 'Falhou',
    successful: 'Sucesso',
    confirmed: 'Confirmado',
  },
  validityText: 'Validade',
  voucherCodeText: 'código do voucher',
  cancelNow: 'Cancelar agora',
  cabService: 'Serviço de táxi',
  from: 'de',
  to: 'a',
  car: 'Carro',
  errorMsgs: { bookingCancelled: 'Reserva cancelada com sucesso' },
};

const footerComponent: FooterComponentTexts = {
  faqLabel: 'FAQ',
  poweredBy: 'Desenvolvido por',
  privacyPolicyLabel: 'Política de Privacidade',
  termsAndConditionsLabel: 'Termos e Condições',
};

const headerComponent: HeaderComponentTexts = {
  logoutButtonLabel: 'Sair',
  searchBarPlaceholder: 'Pesquisar marcas ou comerciantes',
  search: 'Pesquise',
};

const loginModal: LoginModalTexts = {
  faqLine: {
    before: 'Consulte nossas',
    link: 'Perguntas Frequentes',
    after: 'para obter mais detalhes',
  },
  landingSectionTitle:
    'Forneça os dados do seu cartão e verifique sua elegibilidade',
  heading: 'Desbloqueie seus benefícios',
  registerButtonLabel: 'Desbloquear minhas ofertas',
  returningUserLabel: 'Usuário já registrado?',
  cardNumberLabel: 'Digite o número do seu cartão Visa',
  emailIdLabel: 'Digite seu e-mail de login',
  emailIdErrorMsg: 'Por favor, insira um e-mail válido',
  consent1: { text: 'Ao fazer login, você concorda com nossos' },
  consent2: {
    body: `Ao marcar esta caixa, você concorda que a Visa pode coletar, usar, processar e compartilhar suas informações pessoais para administrar e gerenciar a campanha de acordo com o`,
    link: 'Aviso de Privacidade Global da Visa.',
  },
  pcidssText:
    'Os números do cartão e da conta são usados apenas para verificar sua elegibilidade e são criptografados.',
  tryAgain: 'Tente novamente',
  authPassMsg: 'Autenticação bem-sucedida!',
  authFailMsg: 'Falha na autenticação!',
  waitingForBank: 'Aguardando seu banco...',
  unlockingVouchers: 'Desbloqueando seus vouchers...',
  takeFewMinutes: 'Isso pode levar alguns minutos',
  visaCard: 'Cartão Visa',
  expiryDate: 'Data de validade (MM/AA)',
  redirectionText: {
    title: 'Você será redirecionado para o site do emissor*',
    subtitle:
      '*A Visa não se responsabiliza por quaisquer erros de comunicação entre você e o emissor',
  },
  otpMessages: {
    resend: 'Reenviar OTP',
    sent: 'OTP reenviado com sucesso',
    resendIn: 'Reenviar OTP em',
    enter: 'Digite o OTP enviado para',
    request: 'Solicitar OTP',
    invalid: 'OTP inválido.',
    maxInvalid: 'Número máximo de tentativas de OTP inválidas atingido.',
    attemptsLeft: 'restam {{attempts}} tentativa(s).',
    tooltip:
      'Verifique sua pasta de spam se não recebeu o OTP na caixa de entrada',
  },
  change: 'Alterar',
  submitBtnTitles: {
    proceed: 'Continuar',
    authCard: 'Autenticar Cartão',
    submit: 'Enviar',
    requesting: 'Solicitando',
  },
  cardVerification: 'Verificação do cartão',
  placeholders: { month: 'MM', year: 'AA' },
  errorMsgs: {
    invalidCard: 'Número do cartão inválido',
    cardAlreadyMappedWithEmail:
      'O cartão já está vinculado a outro e-mail. Use seu e-mail registrado para fazer login',
    cardNotEligible:
      'O número do cartão inserido não é elegível. Tente novamente com um cartão elegível',
    invalidUserCredentials: 'Insira um e-mail ou cartão válido/registrado',
    verificationFailed:
      'Falha na verificação. Por favor, tente novamente mais tarde',
    defaultErrorMsg1: 'Insira um e-mail válido/registrado para fazer login',
    defaultErrorMsg2:
      'O e-mail inserido não está registrado. Digite seu e-mail registrado para fazer login ou registre-se com seu cartão e e-mail.',
    tryAgain: 'Tente novamente em {{time}} minutos',
    expiry: {
      month: {
        invalid: `O mês de vencimento é inválido`,
        required: `O mês de validade é obrigatório`,
      },
      year: {
        required: `O ano de validade é obrigatório`,
        invalid: `O ano de validade é inválido`,
      },
    },
  },
};

const cardSelectionDropdown: CardSelectionDropdownTexts = {
  addNewCard: 'Adicionar novo cartão',
  reVerify: 'Re-verificar',
  unverified: 'Não verificado',
};

const detailsPage: DetailsPageTexts = {
  about: 'Sobre',
  orderDetails: 'Detalhes do pedido',
  amount: 'Valor',
  discount: 'Desconto',
  totalPrice: 'Preço Total',
  payNow: 'Pagar Agora',
  redeemed: 'Resgatado',
  buyNow: 'Comprar Agora',
  redeemNow: 'Resgatar Agora',
  readMore: 'Leia Mais',
  readLess: 'Leia Menos',
  errorMsgs: {
    failedBooking: 'Falha ao criar reserva',
  },
};

export const languageSpecificConfigs = {
  reverificationLogoutText,
  preLoginPage,
  offerListingPage,
  orderHistoryPage,
  footerComponent,
  headerComponent,
  commonTexts,
  loginModal,
  cardSelectionDropdown,
  detailsPage,
};
